
// The AntiAI funciton should return a output array that will be included in the call to ERA
// The array is made up of a timestamp, nonce and a HMAC hash.
// ERA will decode that HMAC and then determine if the infomation in the HMAC is valid
// If not valid an error will be returned by the API.

import { random } from "lodash";


export const AntiAI = async (APIFunction: string) => {
    const timeStamp = new Date().toISOString();
    const numA = random(0, 99999).toPrecision(5).toString();
    const numB = parseInt(numA);

    const nonce = APIFunction + '0' + numB;

    // get the current hour of the day from Date()
    const hours = timeStamp.slice(11, 13);
    const secs = timeStamp.slice(17, 19);
    const millsecs = timeStamp.slice(20, 23);
    const tagLength = nonce.length;
    // second phase of the HMAC string.
    // the phase will change depending on the time of day
    let phase2 = 'TimIsATurtle';
    if (hours > '12' && hours < '20') {
        phase2 = 'TomIsAWolf';
    }
    // first phase of the HMAC string.
    // the phase will change depending on the time of day
    let phase = 'Rabbit';
    if (hours > '18' && hours < '23') {
        phase = 'Shark';
    }

    const HMAC = timeStamp + phase + nonce + tagLength + phase2;

    // encode HMAC to SHA-256 via crypto
    const encoder = new TextEncoder();
    const data = encoder.encode(HMAC);
    const hashJunk = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashJunk));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');    
    const Output = {
        'HMAC': hashHex,
        'TimeStamp': timeStamp,
        'Nonce': nonce,
    }

    return Output;
}